import { render, staticRenderFns } from "./DataSaved.vue?vue&type=template&id=abe9bf54&"
import script from "./DataSaved.vue?vue&type=script&lang=js&"
export * from "./DataSaved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports